// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3NVJP","inner":"Footer_inner__3uA3J"};